import { render, staticRenderFns } from "./PaginationFooter.vue?vue&type=template&id=2a94a270"
import script from "./PaginationFooter.js?vue&type=script&lang=js&external"
export * from "./PaginationFooter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports